import React, { createContext } from "react";

export interface DataConfigContextProps {
  collectionConfig: Record<string, DatasetEntry>;
  storageCollectionConfig: Record<string, StorageDatasetEntry>;
  groupConfig: Record<string, DatasetGroup>;
  featuredIds: string[];
}

const initialState: DataConfigContextProps = {
  collectionConfig: {},
  storageCollectionConfig: {},
  groupConfig: {},
  featuredIds: [],
};

const DataConfigContext = createContext<DataConfigContextProps>(initialState);

export const DataConfigProvider: React.FC<DataConfigContextProps> = ({
  children,
  collectionConfig,
  storageCollectionConfig,
  groupConfig,
  featuredIds,
}) => {
  const context: DataConfigContextProps = {
    collectionConfig,
    storageCollectionConfig,
    groupConfig,
    featuredIds,
  };

  return (
    <DataConfigContext.Provider value={context}>
      {children}
    </DataConfigContext.Provider>
  );
};

export const useDataConfig = () => {
  const context = React.useContext(DataConfigContext);
  if (context === undefined) {
    throw new Error("useDataConfig must be used within a DataConfigProvider");
  }
  return context;
};
